import React from 'react'
import HomePart1 from "./HomePart1";
import Navbar from "../Navbar/Navbar.tsx";
import Footer1 from '../Footer/Footer1';
import Footerlast from '../Footer/Footerlast'
const HomePage = () => {
  return (
    <>
    <Navbar/>
        <HomePart1/>
        <Footer1/>
        <Footerlast/>
    </>
  )
}

export default HomePage
